// extracted by mini-css-extract-plugin
export default {"ellipsis":"LoginFlow_ellipsis__TxfWF","refreshingLogoutButton":"LoginFlow_refreshingLogoutButton__yQO7R"};